import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class ProduccionService {
  async getOrdenesProduccion() {
    return await fetchWrapper.get(`${ruta}/ordenproduccion`);
  }

  async crearOrdenProduccion(payload) {
    return await fetchWrapper.post(`${ruta}/ordenproduccion`, payload);
  }

  async anularOrdenProduccion(id, motivo) {
    return await fetchWrapper.post(`${ruta}/ordenproduccion/${id}/anular`, {
      motivo_anulacion: motivo
    });
  }
}
